import { CampagneSocieteCaracteristiqueSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const CampagneSocieteCaracteristiqueModel: SelectorModel = {
  name: 'campagneSocieteCaracteristiques',
  getSelector: CampagneSocieteCaracteristiqueSelectors.selectAllCampagneSocieteCaracteristiquesDictionary,
  isReady: CampagneSocieteCaracteristiqueSelectors.selectIsReadyCampagneSocieteCaracteristique
};
